<template>
  <div>
    <p class="total-number my-7">
      <span class="text-3xl font-bold">{{ data.total }}</span>
      {{ $t("dashboard.total") }}
    </p>
    <div class="list-avatar mb-8 flex items-center">
      <div
        class="flex flex-col items-center mr-3"
        v-for="(student, index) in studentOverview"
        :key="student.username + index"
      >
        <md-avatar class="w-[50px] h-[50px] avatar-overview">
          <img
            :src="student.avatar_url || '/img/avt_placeholder.jpg'"
            alt="Avatar"
          />
        </md-avatar>
        <p class="student-name text-xs font-normal">
          {{ student.username }}
        </p>
      </div>
      <div class="flex flex-col items-center pt-1.5" v-if="data.total > 4">
        <div class="see-more-students rounded-full">
          <span class="text-white text-sm font-medium">
            {{ data.total - 4 }} +
          </span>
        </div>
        <p class="invisible">none</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "student-overview",
  props: ["data"],
  computed: {
    studentOverview() {
      return this.data.list?.slice(0, 4);
    }
  }
};
</script>
<style lang="scss" scoped>
.total-number {
  color: #d0d1d2;
  span {
    color: #11263c;
  }
}
.list-avatar {
  .student-name {
    color: #404040;
  }
}
.see-more-students {
  background-color: #197bbd;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

@media screen and (min-width: 960px) and (max-width: 1919px) {
  .avatar-overview,
  .see-more-students {
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
  }

  .student-name {
    max-width: 50px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
